"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var components_1 = require("stremio/components");
var EPG_1 = require("stremio/common/EPG");
var Row_less_1 = __importDefault(require("./Row.less"));
var COMPACT_WIDTH = 80;
var ICON_MIN_WIDTH = 20;
var formatTime = function (time) { return new Date(time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }); };
var Row = function (_a) {
    var _b, _c, _d, _e;
    var channel = _a.channel, programs = _a.programs, currentProgramIndex = _a.currentProgramIndex, dayStart = _a.dayStart, dayEnd = _a.dayEnd, visibleStart = _a.visibleStart, visibleEnd = _a.visibleEnd, pixelsPerHour = _a.pixelsPerHour, onProgramClick = _a.onProgramClick;
    var t = (0, react_i18next_1.useTranslation)().t;
    var totalWidth = ((dayEnd - dayStart) / EPG_1.HOUR_IN_MS) * pixelsPerHour;
    var channelHref = (_e = (_c = (_b = channel.deepLinks) === null || _b === void 0 ? void 0 : _b.metaDetailsStreams) !== null && _c !== void 0 ? _c : (_d = channel.deepLinks) === null || _d === void 0 ? void 0 : _d.metaDetailsVideos) !== null && _e !== void 0 ? _e : null;
    return (react_1.default.createElement("div", { className: Row_less_1.default['row'] },
        react_1.default.createElement("div", { className: Row_less_1.default['programs'], style: { width: totalWidth } },
            programs.map(function (program, index) {
                var _a;
                var _b;
                var startMs = (0, EPG_1.programStartMs)(program);
                var endMs = (0, EPG_1.programEndMs)(program);
                if (endMs <= visibleStart || startMs >= visibleEnd) {
                    return null;
                }
                var left = Math.max(0, ((startMs - dayStart) / EPG_1.HOUR_IN_MS) * pixelsPerHour);
                var width = ((Math.min(endMs, dayEnd) - Math.max(startMs, dayStart)) / EPG_1.HOUR_IN_MS) * pixelsPerHour;
                var compact = width < COMPACT_WIDTH;
                return (react_1.default.createElement("div", { key: (_b = program.id) !== null && _b !== void 0 ? _b : startMs, className: (0, classnames_1.default)(Row_less_1.default['program'], (_a = {}, _a[Row_less_1.default['current']] = index === currentProgramIndex, _a[Row_less_1.default['compact']] = compact, _a)), style: { left: left, width: width } },
                    react_1.default.createElement(components_1.Button, { role: 'button', className: Row_less_1.default['program-inner'], style: { width: width - Math.min(4, width / 4) }, title: program.title, onClick: function () { return onProgramClick(program, channel); } },
                        compact && width >= ICON_MIN_WIDTH ?
                            react_1.default.createElement(react_2.default, { className: Row_less_1.default['program-icon'], name: 'details' })
                            :
                                null,
                        program.thumbnail ?
                            react_1.default.createElement("div", { className: Row_less_1.default['program-thumb'], style: { backgroundImage: "url('".concat(program.thumbnail, "')") } })
                            :
                                null,
                        react_1.default.createElement("div", { className: Row_less_1.default['program-content'] },
                            react_1.default.createElement("div", { className: Row_less_1.default['program-title'] }, program.title),
                            react_1.default.createElement("div", { className: Row_less_1.default['program-time'] },
                                formatTime(startMs),
                                react_1.default.createElement("span", null, "-"),
                                formatTime(endMs))))));
            }),
            programs.length === 0 ?
                react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(Row_less_1.default['program-inner'], Row_less_1.default['no-programs']), href: channelHref !== null && channelHref !== void 0 ? channelHref : undefined, title: channel.name },
                    react_1.default.createElement("div", { className: Row_less_1.default['program-content'] },
                        react_1.default.createElement("div", { className: Row_less_1.default['program-title'] }, channel.name),
                        react_1.default.createElement("div", { className: Row_less_1.default['program-time'] }, t('LIVE_TV_NO_SCHEDULE', { defaultValue: 'Programme information is unavailable for this channel.' }))))
                :
                    null)));
};
exports.default = (0, react_1.memo)(Row);
